export default "__VITE_ASSET__BJiN88Rq__"